import User from "../User.jsx"
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import config from '../../config.js';
import { Link } from 'react-router-dom';
import DocumentButton from '../Buttons/DocumentButton';
import { useState } from 'react';
import { useCollapse } from 'react-collapsed'

const PanelDevis = ({ devis }) => {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse()

   
    const montants = [
        {
            key: 'total',
            name: 'Montant HT'
        }, {
            key: 'montant_du',
            name: 'Montant TTC',
        }
    ]

    const btn_classes = ' py-1 px-3 rounded-3xl text-xs sm:text-sm'

    let state_class;

    switch (parseInt(devis.label)) {
        case 2:
            state_class = 'text-red-500';
            break;

        case 4:
            state_class = 'text-mlime';
            break;

        default:
            state_class = 'text-morange';
            break;
    }

    return (
        <div
            className="relative block overflow-hidden rounded-lg py-4 px-2 "
        >
            <div className="flex justify-between gap-4 mb-3 items-center">
                <div className="font-bold text-mdark">
                    {devis.no_facture}
                </div>

                <div>
                    <span className={`${state_class} py-1 pl-2 font-bold text-sm rounded-md`}>{devis.label_name}</span>
                </div>
            </div>

            <div className="flex gap-8 justify-between mb-4">
                <div className="flex gap-8">
                    {montants.map((m) =>
                        <div>
                            <div className="text-xs text-gray-500">{m.name}</div>
                            <div className="text-sm font-bold">{devis[m.key]} €</div>
                        </div>
                    )}

                </div>
                <div className="text-gray-400 text-sm italic">{format(devis.date_devis, 'dd/MM/yyyy')}</div>
            </div>

            <div className="my-2">
                <User user={devis.user} />
            </div>
           

            <div className="actions flex justify-between gap-2 ">
                <button {...getToggleProps()}  className={`bg-transparent border border-gray-400 text-mdark whitespace-nowrap  ${btn_classes}`}>
                    {isExpanded ? 
                        <>
                            Masquer les prestations
                            <FontAwesomeIcon className="ml-2" icon="fa-solid fa-chevron-up" />
                        </>
                        : 
                        <>
                            Afficher les prestations
                            <FontAwesomeIcon className="ml-2" icon="fa-solid fa-chevron-down" />                        
                        </>                        
                    }
                </button>

                <DocumentButton
                    filename={devis.filename + '.pdf'}
                    file_type="devis"
                    buttonTitle="Voir le PDF"
                    className={`bg-mlime hover:bg-lime-600 font-bold ${btn_classes}`}
                    icon="fa-file-pdf"
                    loader={{size: '80%', firstColor: 'white', secondColor: '#eeeeee88'}}

                />
            </div>

            {devis.prestations && (
                <div {...getCollapseProps()} className={`prestations transition-all duration-500 ease-in-out `}>
                    <ul className="divide-y divide-gray-200">
                        {devis.prestations.map((p, i) => {
                            const total = p.qte * p.prix;
                            const reduction = parseFloat(p.reduction);
                            const totalAvecReduction = total - (total * reduction) / 100;

                            return (
                                <li key={p.id} className="py-4">
                                    <div className="flex justify-between presta-info">
                                        <div className="flex-1">
                                            <div className="font-semibold">{p.designation}</div>
                                            <div className="text-sm text-gray-500">{p.details}</div>
                                            {p.note && <div className="text-xs text-gray-400 mt-1">{p.note}</div>}
                                        </div>
                                        <div className="presta-price flex-shrink-0 ml-4 text-right">
                                            <div className="font-semibold">{totalAvecReduction} €</div>
                                            {p.reduction > 0 && <div className="text-xs text-gray-400 line-through">{total} €</div>}
                                            <div className="text-xs text-gray-400">({p.prix} € / unité)</div>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center mt-2">
                                        <div className="text-xs text-gray-400">Quantité: {p.qte}</div>
                                        {p.reduction > 0 && <div className="text-xs text-red-500">Réduction: {reduction}%</div>}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            )}


        </div>
    )
}
export default PanelDevis;